import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Pricing from "./pages/Pricing";
import Auth from "./pages/Auth";
import AuthCallback from "./pages/AuthCallback";
import DashboardLayout from "./pages/DashboardLayout";
import DashboardHome from "./pages/DashboardHome";
import ScriptStudio from "./pages/ScriptStudio";
import CaptionStudio from "./pages/CaptionStudio";
import TitleStudio from "./pages/TitleStudio";
import ThumbnailStudio from "./pages/ThumbnailStudio";
import VoiceoverStudio from "./pages/VoiceoverStudio";
import BrollStudio from "./pages/BrollStudio";
import BrollHistory from "./pages/BrollHistory";
import Competitor from "./pages/Competitor";
import Trends from "./pages/Trends";
import Workspace from "./pages/Workspace";
import Analytics from "./pages/Analytics";
import Settings from "./pages/Settings";
import Admin from "./pages/Admin";
import AdminPayouts from "./pages/AdminPayouts";
import Editor from "./pages/Editor";
import Calendar from "./pages/Calendar";
import Affiliate from "./pages/Affiliate";
import Blog from "./pages/Blog";
import Help from "./pages/Help";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

const Private = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-white/60">Loading...</div>;
  if (!user) return <Navigate to="/auth" replace />;
  return children;
};

const AppRouter = () => {
  const location = useLocation();
  // Detect OAuth callbacks synchronously during render (prevents race condition)
  if (location.hash?.includes("session_id=") || location.hash?.includes("token=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/help" element={<Help />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/auth-callback" element={<AuthCallback />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/app" element={<Private><DashboardLayout /></Private>}>
        <Route index element={<DashboardHome />} />
        <Route path="script" element={<ScriptStudio />} />
        <Route path="caption" element={<CaptionStudio />} />
        <Route path="titles" element={<TitleStudio />} />
        <Route path="thumbnail" element={<ThumbnailStudio />} />
        <Route path="voiceover" element={<VoiceoverStudio />} />
        <Route path="broll" element={<BrollStudio />} />
        <Route path="broll-history" element={<BrollHistory />} />
        <Route path="competitor" element={<Competitor />} />
        <Route path="trends" element={<Trends />} />
        <Route path="workspace" element={<Workspace />} />
        <Route path="calendar" element={<Calendar />} />
        <Route path="affiliate" element={<Affiliate />} />
        <Route path="editor" element={<Editor />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="settings" element={<Settings />} />
        <Route path="admin" element={<Admin />} />
        <Route path="admin/payouts" element={<AdminPayouts />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster theme="dark" position="top-right" richColors />
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
